<div>
    <div class="meta" itemscope="" itemtype="https://schema.org/BreadcrumbList">
        <div class="container p-0 px-md-3">
            <span itemprop="itemListElement" itemscope="" itemtype="https://schema.org/ListItem">
              <a itemprop="item" href="/spora" rel="category tag">
                <span itemprop="name">Шпоры</span>
              </a>
              <meta itemprop="position" content="1">
            </span>
        </div>
    </div>

    <transition name="fade">
        <div v-show="dataLoading" class="form-loader"></div>
    </transition>

    <!-- Modal -->
    <div class="modal fade" id="errorModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Ошибка</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <p v-for="error in v$.$errors">
                        <strong>{{ formAttrs[error.$property].title }}:</strong>
                        {{ error.$message }}
                    </p>

                    <p
                        v-if="responseError"
                        v-html="responseError"
                    ></p>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary" data-bs-dismiss="modal">
                        Ок
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- Modal -->
    <div class="modal fade" id="confirmModal" tabindex="-2" aria-labelledby="confirmModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Внимание!</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <p
                        v-if="confirmText"
                        v-html="confirmText"
                    ></p>
                </div>
                <div class="modal-footer d-flex justify-content-center">
                    <button type="button" class="btn btn-finaly" data-bs-dismiss="modal" @click="nextStep()">
                        Да, оформить заказ

                        <transition name="fade">
                            <div v-show="formLoader" class="preloader"></div>
                        </transition>
                    </button>
                    <button type="button" class="btn btn-primary" data-bs-dismiss="modal" style="border-radius: .25rem; font-family: inherit;">
                        Вернуться
                    </button>
                </div>
            </div>
        </div>
    </div>

    <div v-if="!dataLoading" class="header-content" id="order-block">
        <div class="container py-2">
            <h1 style="text-align: center;">
                Шпаргалки для 9 классов и колледжей — 2025 год
            </h1>
        </div>

        <div class="container privilege-container">

            <div v-if="false" class="owl-carousel owl-theme">
                <div class="slide-item">
                    <div class="slider-container">
                        При заказе от 10 шпаргалок оплату пересылки мы берём на себя.
                    </div>
                </div>
                <div class="slide-item">
                    <div class="slider-container">
                        Заказ отправляем в течение 2 рабочих дней после оформления из Минска Белпочтой (бизнес-почтой), поэтому у нас самая быстрая доставка. Посылка придёт на следующий день после отправки..
                    </div>
                </div>
                <div class="slide-item">
                    <div class="slider-container">
                    Посылку вы оплачиваете только при получении в отделении почты (наложенный платёж).
                    </div>
                </div>
                <div class="slide-item">
                    <div class="slider-container">
                    Вы всегда будете проинформированы о статусе заказа сообщениями на указанный номер в заказе или в ВК. А после отправки придёт ещё и ссылка на отслеживание вашей посылки.
                    </div>
                </div>
            </div>

            <div class="row">
                <PrivilegeItem
                    v-for="(item, i) in privilege"
                    :item="item"
                    :is-open="openCollapseId === i"
                    @open="openCollapseId = (openCollapseId === i ? null : i)"
                />

                <div class="privilege-item col-12 mb-2" style="padding-top: 20px;">
                    <div class="privilege-title">
                        <i class="fas fa-check mr-2" style="visibility: hidden"></i>
                        <a href="#reviews">
                            Отзывы ⬅️
                        </a>
                    </div>
                </div>

            </div>
        </div>

        <div class="tabs-container">
            <div class="container pb-0 pb-3 pt-0">
                <span
                    v-for="filter in filters"
                    class="tab-item"
                    :class="{active: currentFilter === filter.class}"
                    @click="setFilter(filter.class)"
                >
                    {{ filter.title }}
                </span>
            </div>
        </div>

    </div>

    <div class="content market">
        <div v-if="form.byType === 0 && config.count_for_delivery_free" class="product-progress-container container">
            <div v-if="countToNextDiscountStep > 0" class="small mb-1" style="height: 1rem;">
                {{ nextDiscountStep.title }}: {{ countToNextDiscountStep }} шт.
            </div>
            <div class="product-progress-bar-b" :class="{'product-progress-is-full': deliveryIsFree}">
                <div class="product-progress-bar">
                    <div
                        class="product-progress-line"
                        :style="{width: percToFreeDelivery + '%'}"
                    ></div>
                </div>
            </div>
        </div>

        <div v-if="form.byType === 0" class="toast-container">
            <transition-group name="fly">
                <div v-for="toast in toasts" :key="toast.id" class="toast-item">
                    <div v-html="toast.text" class="toast-content"></div>
                    <div @click="deleteNotify(toast.id)" class="toast-close-ic">×</div>
                </div>
            </transition-group>
        </div>

        <!--        <FreeDeliveryNotify-->
        <!--            :min-count="config.count_for_delivery_free"-->
        <!--            :current-count="totalCountInCart"-->
        <!--            :is-free="deliveryIsFree"-->
        <!--        />-->

        <div class="container">
            <div class="row">
                <ProductItem
                    v-for="product in displayedProducts"
                    :key="product.id"
                    :product="product"
                    :promo-is-on="promoIsOn"
                    :value="productInCartCount(product.id)"
                    @decrement="addProduct(product.id, -1)"
                    @increment="addProduct(product.id, 1)"
                    @set-value="inputProductCount(product.id, $event)"
                />
            </div>
        </div>

    </div>

    <div class="content market" style="background: #ECEFF1;margin-bottom: 20px;">
        <div class="container">

            <div v-if="config.minsk_show" class="by-type-container d-flex justify-content-center">
                <div
                    class="btn-by-type"
                    :class="{active: form.byType === 0}"
                    @click="setByType(0)"
                >
                    Почтой
                </div>
                <div
                    v-if="config.minsk_show"
                    class="btn-by-type"
                    :class="{active: form.byType === 1}"
                    @click="setByType(1)"
                >
                    Доставка по Минску (10 руб.)
                </div>
            </div>

            <div v-if="config.minsk_show" class="text-center pt-2 text-muted">
                Выбрано: {{ form.byType === 0 ? 'почтой' : 'доставка по Минску' }}
            </div>

            <Form
                :form="form"
                :v="v$"
            />

            <br>
        </div>
    </div>

    <div class="container">

        <div class="row" id="cart-scroll" ref="finalBlock">

            <div v-if="false" class="col-12 col-md-6">

                <div class="discount_block" :class="{'pulse-anim': pulseA}">

                    <transition name="fade">
                        <div v-show="promoLoader" class="form-loader"></div>
                    </transition>

                    <h3 class="title-block">Промокод</h3>

                    <p v-if="!promoIsOn">Если у вас есть промокод, введите его здесь.</p>

                    <div class="row">
                        <div class="col-lg-8 mb-2 mb-lg-0 promo-input" v-if="!promoIsOn">
                            <input type="text" placeholder="Промокод" v-model="promoCode" class="b-fluid">
                        </div>
                        <div class="col-lg-4 promo-input-btn-container" v-if="!promoIsOn">
                            <button @click="promoCheck" class="btn-form-promo" :class="{'disabled': !promoCode}">
                                Применить
                            </button>
                        </div>

                        <div class="col-12 " v-if="promocode && promoIsOn">
                            <span class="promo-label">
                                {{ promoCode }}
                            </span>
                        </div>

                        <div class="col-12 mt-2" v-show="promoIsInvalid">
                            <div class="promo-danger-label">Недействительный промокод</div>
                        </div>

                        <div class="col-12 mt-2" v-if="promoIsOn && !promoIsInvalid">
                            <div class="promo-success-label">Промокод применён</div>

                            <span>
                                Все шпаргалки по 4 руб.
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12 col-md-6">
                <div class="discount_block">
                    <h3 class="title-block">Проверьте ваш заказ</h3>
                    <div class="b-sum-check-t" v-if="totalCountInCart > 0">
                        Вы выбрали
                    </div>
                    <span style="color:#e53935;">{{ totalCountInCart ? '' : 'Не выбрано ни одной шпаргалки' }}</span>
                    <div v-for="item in productsInCart" :key="item.productId">
                        <div>
                            {{ item.product.title }}
                            {{ item.product.class == 9 ? `${item.product.class} класс` : 'для колледжей' }}
                            {{ item.count }} шт. — {{ $filters.currencyFormatted(item.price) }}
                        </div>
                    </div>
                    <div v-if="totalCountInCart > 0" style="margin-top: 15px;">
                        <hr>

                        <div>
                            <span v-if="currentDiscountStep && currentDiscountStep.discountLabel" class="small px-2 py-1"
                                  style="background: #f5f5f5; border-radius: 3px;">
                                Скидка {{ currentDiscountStep.discountLabel }}
                            </span>
                        </div>

                        Стоимость шпаргалок —
                        <span v-if="priceDiscount < totalPriceInCart" class="discount-benefit">
                            {{ $filters.currencyFormatted(priceDiscount) }}
                        </span>

                        <span :class="{'price-discount': priceDiscount < totalPriceInCart}">
                            {{ $filters.currencyFormatted(totalPriceInCart) }}
                        </span>

                        <br>
                        <div>Стоимость {{ form.byType === 0 ? 'пересылки' : 'доставки' }} —
                            <span v-if="deliveryIsFree"><b>бесплатно</b></span>
                            <span v-else-if="form.byType === 0">5 руб. 76 коп.</span>
                            <span v-else-if="form.byType === 1">10 руб.</span>
                        </div>
                        <div>
                            <b>Итого:</b> {{ $filters.currencyFormatted(priceDiscount + deliveryPrice) }}
                        </div>
                    </div>

                    <div v-if="form.name">
                        <hr>
                        <div class="b-sum-check-t">
                            Ваши контактные данные
                        </div>
                        ФИО: {{ fullName }}<br>
                        Телефон: {{ form.phone ? '+375' + form.phone : '' }}<br>
                        Адрес: {{ selectedAddressString }}
                        <div v-if="form.index">
                            Индекс: {{ form.index }}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="form-group b-nav-order-step b-sum-check">

            <div class="container">
                <div v-if="config.delivery_date">
                    Дата доставки:<br>
                    <b style="color: #ff6d45">
                        {{ config.delivery_date }}
                    </b>
                </div>
            </div>

            <div class="container mb-4 d-flex justify-content-center">
                <div class="btn-finally-container">
                    <button
                        @click="nextStep(false)"
                        :disabled="!totalCountInCart"
                        type="button"
                        class="btn-form btn-finaly"
                        ref="sendForm"
                    >
                        Оформить заказ
                    </button>

                    <div v-if="false" class="mt-3 text-muted small">
                        Оформляя заказ, вы присоединяетесь к договору
                        <a href="/dogovor_oferty_superresheba_by.pdf" target="_blank">
                            публичной оферты
                        </a>
                    </div>

                    <transition name="fade">
                        <div v-show="formLoader" class="preloader"></div>
                    </transition>
                </div>
            </div>
        </div>

    </div>

    <div class="how-get-product">
        <div class="container block">
            <div class="row">
                <div class="col-12 col-sm-12 col-md-6">
                    <a name="how-post" id="how-post"></a>
                    <h3 class="title-block">Как купить шпоры почтой</h3>
                    <p><b>Шаг 1.</b> Вы оформляете заказ на нашем сайте.</p>
                    <p><b>Шаг 2.</b> Заказ отправляем в течение 2 рабочих дней после оформления из Минска Белпочтой (бизнес-почтой), поэтому у нас самая быстрая доставка.
                        Посылка придёт на следующий день после отправки.</p>
                    <p><b>Шаг 3.</b> После этого вы получаете сообщение на указанный при оформлении заказа номер телефона со ссылкой на отслеживание вашей посылки.</p>
                    <p><b>Шаг 4.</b> Когда посылка придёт в ваше почтовое отделение,
                        вы получите СМС-уведомление.
                        Вам нужно будет подойти на вашу почту, захватив с собой паспорт,
                        и забрать посылку. Работник почты попросит внести соответствующую оплату и
                        выдаст вашу посылку.</p>
                </div>
            </div>
        </div>
    </div>

    <div class="why-order-from-us b-black">
        <div class="container block">
            <h3 class="title-block">Часто задаваемые вопросы</h3>
            <div class="row">

                <div class="col-12 faq-item">
                    <div class="faq-title">
                        <i class="fas fa-chevron-circle-right mr-2"></i>
                        Сколько стоит доставка?
                    </div>
                    <div class="faq-answer">
                        Стоимость пересылки (согласно тарифам Белпочты) составляет 5 руб. 76 коп. При заказе от 10 шпор
                        пересылка <b>бесплатная</b>.
                    </div>
                </div>

                <div class="col-12 faq-item">
                    <div class="faq-title">
                        <i class="fas fa-chevron-circle-right mr-2"></i>
                        Совпадут ли задания на экзамене и в шпаргалке?
                    </div>
                    <div class="faq-answer">
                        Да, в шпаргалках есть решения на все задания, которые только могут попасться на экзамене.
                    </div>
                </div>

                <div class="col-12 faq-item">
                    <div class="faq-title">
                        <i class="fas fa-chevron-circle-right mr-2"></i>
                        Как я узнаю, что шпоры уже пришли?
                    </div>
                    <div class="faq-answer">
                        После прибытия посылки в ваше почтовое отделение на указанный в заказе номер телефона придёт
                        уведомление.
                        Кроме того, сразу после отправки вам поступит сообщение со ссылкой на отслеживание посылки.
                    </div>
                </div>

                <div class="col-12 faq-item">
                    <div class="faq-title">
                        <i class="fas fa-chevron-circle-right mr-2"></i>
                        Можно купить электронную версию?
                    </div>
                    <div class="faq-answer">
                        У нас есть БЕСПЛАТНЫЕ электронные онлайн-шпаргалки по истории Беларуси для 9 класса.
                        При необходимости вы сможете скопировать текст в Word и сделать шпоры самостоятельно или вывести
                        текст на часах-шпаргалке.
                    </div>
                </div>

            </div>
        </div>

    </div>

    <div class="container block" id="reviews">
        <h3 class="title-block">Отзывы в ВК</h3>
        <div class="reviews-container">

            <div v-for="review in reviews" :key="review.id" class="reviews-item">
                <div class="r-img-block">
                    <img :src="review.photo_50">
                </div>
                <div class="r-text-block">
                    <div class="r-link-b">
                        <a :href="'https://vk.com/id' + review.from_id" target="_blank" class="r-link-profile">
                            {{ review.first_name }} {{ review.last_name }}
                        </a>
                        <a :href="'https://vk.com/topic-81631540_35161381?post=' + review.id" target="_blank"
                           class="text-small d-none d-md-inline text-muted ms-2 r-link-post">
                            {{ review.date }}
                        </a>
                    </div>
                    <div class="r-text-b">{{ review.text }}</div>
                    <a :href="'https://vk.com/topic-81631540_35161381?post=' + review.id" target="_blank"
                       class="text-small d-inline d-md-none text-muted mt-2 r-link-post">
                        {{ review.date }}
                    </a>
                </div>
            </div>

            <a href="https://vk.com/topic-81631540_35161381" target="_blank" class="btn-vk-reviews">
                Читать другие отзывы
            </a>

            <p class="text-center mt-3 mb-0">
                Ещё больше отзывов в нашем Instagram:<br>

                <a href="https://www.instagram.com/superresheba.by/" target="_blank"
                   class="mt-2 d-flex align-items-center justify-content-center" style="line-height: 1">
                    <span class="me-2" style="width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    border-radius: 50%;
    background: linear-gradient(45deg, #4c60d1, #e32c6a);">
                        <i class="fab fa-instagram"></i>
                    </span>
                    superresheba.by
                </a>
            </p>

        </div>
    </div>

    <div class="b-market-desc">
        <div class="container py-4">
            <p class="m-0">Шпаргалки на экзамены для белорусских школ и колледжей, актуальные на 2025 год.
                Быстрая доставка почтой в любой город Беларуси (Минск, Гродно, Могилёв, Брест, Витебск, Гомель и
                др.).</p>
        </div>
    </div>

</div>
